
/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
 (function () {

  // 変数
  var rul = {}; // ルール
  var msg = {}; // メッセージ
  var glp = {}; // エラーメッセージのグループ設定

  // グローバル変数　※先にjs/validation/common.jsを読み込んでおく
  var getMsg = window.ohValidateGetMsg; // メッセージリスト
  var changeBlank = window.ohValidateChangeBlank; // 空白変換関数
  var changeHankaku = window.ohValidateChangehankaku; // 半角変換関数

  // 物件の種類
  rul['property_type'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }}
  };
  msg['property_type'] = {
    required:getMsg('required','物件の種類の選択'),
  };

  // 都県
  rul['property_pref'] = {
    required:{depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
  };
  msg['property_pref'] = {
    required:getMsg('required','都県'),
  };

  // 市区町村
  rul['property_city'] = {
    required:{depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
  };
  msg['property_city'] = {
    required:getMsg('required','市区町村'),
  };

  // 町名
  rul['property_town'] = {
    required:{depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
  };
  msg['property_town'] = {
    required:getMsg('required','町名'),
  };

  // 物件所在地：住所２
  rul['property_address2'] = {
    required:{depends: function () {
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 20};
  msg['property_address2'] = {
    required:getMsg('required','丁目・番地など'),
    maxlength:getMsg('max.string', '丁目・番地など', {'max' : '20'}),
  };

  // 物件所在地：マンション名
  rul['property_nm'] = {
    required:{depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return $('#property_type_3').prop('checked')
    }},
    maxlength: 40};
  msg['property_nm'] = {
    required:getMsg('required','マンション名'),
    maxlength:getMsg('max.string', 'マンション名', {'max' : '40'}),
  };

  // 物件所在地：部屋番号
  rul['property_room_no'] = {
    required:{depends: function (element) {
        $(this).val(changeBlank($(this).val()));
        return $('#property_type_3').prop('checked')
    }},
    maxlength: 5};
  msg['property_room_no'] = {
    required:getMsg('required','部屋番号'),
    maxlength:getMsg('max.string', '部屋番号', {'max' : '5'}),
  };

  // メッセージを条件によって出し分けたい場合
  // 専有面積
  var exclusive_area_ary = {1:'土地面積',2:'建物面積',3:'専有面積'};
  rul['exclusive_area'] = {
    // 少数第2位まで許可
    regex:{
      param:"^\\d+(\\.\\d{1,2})?$",
      depends:function(){
        // バリデート前に入力値変換
        return $(this).val(changeHankaku($(this).val()));
    }},
    max:{
      param: 9999,
      depends:function(){
        // バリデート前に入力値変換
        return $(this).val(changeHankaku($(this).val()));
    }},
  };
  msg['exclusive_area'] = {
    regex: function(params, el) {
      var val = $('input[name="property_type"]:checked').val();
      return typeof exclusive_area_ary[val] != 'undefined' ? getMsg('numeric_decimal', exclusive_area_ary[val]) : '';
    },
    max:function(params, el) {
      var val = $('input[name="property_type"]:checked').val();
      return typeof exclusive_area_ary[val] != 'undefined' ? getMsg('max.numeric_less_than', exclusive_area_ary[val],{max: 10000}) : '';
    }
  };

  // 現況（ラジオボタンのためバリデーションなし）

  // 売却希望価格
  rul['price'] = {digits:true, maxlength: 5};
  msg['price'] = {
    digits:getMsg('numeric2','売却希望価格'),
    maxlength:getMsg('max.string','売却希望価格',{'max': '5'}),
  };

  // 名前
  // バリデーション前にvalue変更
  rul['customer_nm'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 40
  };
  msg['customer_nm'] = {
    required:getMsg('required','名前'),
    maxlength:getMsg('max.string', '名前', {'max' : '40'}),
  };

  // ふりがな
  rul['customer_kn'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    kana: true,
    maxlength: 40
  };
  msg['customer_kn'] = {
    required:getMsg('required','ふりがな'),
    kana:getMsg('kana2'),
    maxlength:getMsg('max.string', 'ふりがな', {'max' : '40'})
  };

  // ご希望のご連絡方法（チェックボックスのためバリデーションなし）

  // トリム,空白,半角に自動変換
  // 電話番号
  rul['customer_tel_no'] = {
    required: {
      depends:function(){
        $(this).val($.trim($(this).val()));
        $(this).val(changeBlank($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return true;
      }
    },
    regex: '^(0{1}\\d{1,4}-{0,1}\\d{1,4}-{0,1}\\d{1,4})$',
    maxlength: 13
  };
  msg['customer_tel_no'] = {
    required:getMsg('required','電話番号',),
    regex:getMsg('regex','電話番号'),
    maxlength:getMsg('max.string', '電話番号', {'max' : '13'}),
  };

  // ご希望連絡時間帯（プルダウンのためバリデーションなし）

  // メールアドレス
  // ajaxでバリデートする場合、remoteにURLを指定
  // 現行では全角文字を半角に変換した後にバリデートを掛けているが、その部分をphpコード（validate-email）に追加実装
  rul['customer_email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['customer_email'] = {
    required:getMsg('required','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','メールアドレス'),
  };

  // 郵便番号
  rul['customer_zip_cd'] = {digits: true, maxlength: 7};
  msg['customer_zip_cd'] = {
    digits:getMsg('numeric','郵便番号'),
    maxlength:getMsg('single_bite_digits', '郵便番号',  {'digits' : '7桁の'}),
  };

  // 住所１
  rul['customer_address1'] = {
    maxlength: 40};
  msg['customer_address1'] = {
    maxlength:getMsg('max.string', '住所1', {'max' : '40'}),
  };

  // 住所２
  rul['customer_address2'] = {
    maxlength: 20
  };
  msg['customer_address2'] = {
    maxlength:getMsg('max.string', '住所2', {'max' : '20'}),
  };

  // マンション名
  rul['customer_mansion_nm'] = {
    maxlength: 40};
  msg['customer_mansion_nm'] = {
    maxlength:getMsg('max.string', 'マンション名', {'max' : '40'}),
  };

  // 部屋番号
  rul['customer_room_no'] = {
    maxlength: 5};
  msg['customer_room_no'] = {
    maxlength:getMsg('max.string', '部屋番号', {'max' : '5'}),
  };

  // 相談方法（ラジオボタンのためバリデーションなし）
  // 希望ツール（チェックボックスのためバリデーションなし）
  // 相談希望日1,2（datepickerのためバリデーションなし）
  // 相談希望時1,2（プルダウンのためバリデーションなし）

  // ご質問・ご要望
  rul['consult_txt'] = {
    maxlength: 500};
  msg['consult_txt'] = {
    maxlength:getMsg('max.string', 'ご質問・ご要望', {'max' : '500'}),
  };

  // 個人情報保護方針
  rul['privacy_policy'] = { required: true};
  msg['privacy_policy'] = { required: getMsg('required','個人情報保護方針') };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());


/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {
  // お客様情報
  $(".contact_way-group").on('change', function() {
    $("#contact_way1").valid();
  });
}());

